// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__UV0p2","headline":"styles_headline__qxb6D"};